module.exports = __webpack_public_path__ + "static/img/0507ny_top2.b5766d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/nxzw/0507ny_top2.jpg
// module id = 4V3H
// module chunks = 0